import { render, staticRenderFns } from "./workdayBreaksFilterModal.vue?vue&type=template&id=358774a8&"
import script from "./workdayBreaksFilterModal.vue?vue&type=script&lang=js&"
export * from "./workdayBreaksFilterModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports